<template>
  <v-menu v-if="!hideMenu && canViewMenu">
    <template #activator="{ props }">
      <slot name="activator" :props="props"></slot>
    </template>
    <v-list>
      <v-list-item
        v-if="hasComment && hasCommentPermission"
        @click="$emit('comment-clicked')"
        class="test-comment"
      >
        <v-list-item-title>
          <v-icon>mdi-comment</v-icon>
          Comment
        </v-list-item-title>
      </v-list-item>
      <v-list-item
        v-if="hasEdit"
        @click="$emit('edit-clicked')"
        class="test-pencil"
      >
        <v-list-item-title>
          <v-icon>mdi-pencil</v-icon>
          Edit
        </v-list-item-title>
      </v-list-item>
      <v-list-item
        v-if="hasDelete"
        @click="$emit('delete-clicked')"
        class="test-close"
      >
        <v-list-item-title>
          <v-icon>mdi-close</v-icon>
          Delete
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
  <span v-else>
    <slot name="activator" :props="{}" />
  </span>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import sl from '@/serviceLocator';

export default defineComponent({
  name: 'UtilList',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    hasComment: {
      type: Boolean,
      default: true,
    },
    hasEdit: {
      type: Boolean,
      default: true,
    },
    hasDelete: {
      type: Boolean,
      default: true,
    },
    hideMenu: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['comment-clicked', 'edit-clicked', 'delete-clicked'],
  setup(props) {
    const store = sl.get('store');

    const hasCommentPermission = computed(() =>
      store.hasPermission('ADD_COMMENTS')
    );

    const canViewMenu = computed(
      () =>
        (hasCommentPermission.value && props.hasComment) ||
        props.hasEdit ||
        props.hasDelete
    );
    return { hasCommentPermission, canViewMenu };
  },
});
</script>
